// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__wSb1P","loaderIcon":"Loader_loaderIcon__NH9IK","spin":"Loader_spin__evwg2","fade":"Loader_fade__DJeas"};